import {cartRegister} from "./cartRegister";
import {dataRegister} from "./dataRegister";
import {flowRegister} from "./flowRegister";
import {imagesRegister} from "./imagesRegister";
import queryString from "query-string";
import {themeRegister} from "./themeRegister";
import {salesChannelRegister} from "./salesChannelRegister";
import {userRegister} from "./userRegister";
import {agentRegister} from "./agentRegister";
import {langRegister} from "./langRegister";
import {collectedRegister} from "./collectedRegister";
const hash = require('object-hash');

class carouselRegister {

    static video = {hash: null, url: null};

    static create(){
        let slides = carouselRegister.slides();
        let hash_code = null;
        if(carouselRegister.video.hash){
            hash_code = carouselRegister.video.hash;
        }else{
            try {
                if(JSON.parse(sessionStorage.getItem("carousel")).hash){
                    hash_code = JSON.parse(sessionStorage.getItem("carousel")).hash;
                }
            }catch (e) {}
        }

        if(hash_code !== hash(slides)){
            dataRegister.createSlides({slides: slides}).then((response) => {
                carouselRegister.set(response, hash(slides));
            }, (error) => {
                carouselRegister.set(null);
            });
        }
    }

    static slides(){

        if (collectedRegister.getValue("custom_creative")) {

            let data_custom_creative = {};

            let data = themeRegister.getValue();
            let theme = themeRegister.getTheme();

            let theme_data = themeRegister.getValue();
            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data_custom_creative.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data_custom_creative.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();
            if(user_data && user_data.branding_pref){
                data_custom_creative.branding_image = user_data.branding_image;
            }

            try {

                data_custom_creative.type = JSON.parse(collectedRegister.getValue("type")).title;
                //TODO: type_default only tested in EN and SE lang, other langs need to be tested
                data_custom_creative.type_default = JSON.parse(collectedRegister.getValue("type")).title + " " + collectedRegister.getValue("offering");
                data_custom_creative.offering = collectedRegister.getValue("offering");

                if (theme === "promotion") {
                    data_custom_creative.slogan = theme_data.slogan_offer;
                } else {
                    data_custom_creative.slogan = theme_data.slogan_validation;
                }

                if (collectedRegister.getValue("listing_type").indentifier === "sale") {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("status")).title;
                } else {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("furnishings")).title;
                }

                data_custom_creative.slogan_promo = theme_data.slogan_offer;
                data_custom_creative.slogan_calltoaction = theme_data.last_subtitle;

                data_custom_creative.area = theme_data.theme_region;
                data_custom_creative.building = collectedRegister.getValue("google").autocomplete_address;
                data_custom_creative.city = collectedRegister.getValue("display_region").name;

                data_custom_creative.size = collectedRegister.getValue("size_custom");
                data_custom_creative.beds = JSON.parse(collectedRegister.getValue("bed")).title;
                data_custom_creative.baths = JSON.parse(collectedRegister.getValue("bath")).title;
                data_custom_creative.price = theme_data.last_title;

            } catch (e) {}

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data_custom_creative.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data_custom_creative.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data_custom_creative.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.name){
                    data_custom_creative.agent_name = agent_data.name;
                }
            }else{
                if(user_data && user_data.profile_image){
                    data_custom_creative.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data_custom_creative.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.name){
                    data_custom_creative.agent_name = user_data.name;
                }
            }

            data_custom_creative.first_image = theme_data.first_image;
            data_custom_creative.first_title = theme_data.first_title;
            data_custom_creative.first_subtitle = theme_data.first_subtitle;
            data_custom_creative.last_title = theme_data.last_title;
            data_custom_creative.last_subtitle = theme_data.last_subtitle;

            let query = queryString.stringify(data_custom_creative);
            let images = imagesRegister.get();
            let mainImage = imagesRegister.getMain();
            let mainImageTitle = flowRegister.getValue("main_image_title");
            let items = Array.isArray(flowRegister.getValue("video_items"))?flowRegister.getValue("video_items"):[];
            let location = flowRegister.getValue("display_region");
            let industry = "";
            try {
                industry = cartRegister.get().industry.name;
            }catch (e) {}
            let slides = [];

            /*
            let type = themeRegister.getThemeType();
            let extra_image = "";
            if(type !== "no_theme" && data){
                let user_data = userRegister.getUser();
                if(type === "agent_theme" && user_data && user_data.profile_image){
                    data.theme_type = type;
                    extra_image = user_data.profile_image;
                }
                if(type === "agency_theme" && user_data && user_data.logo_image){
                    data.theme_type = type;
                    extra_image = user_data.logo_image;
                }
            }
             */

            if(mainImage){
                let slide = {
                    image: mainImage.images.small,
                    image_title: mainImageTitle,
                    title: mainImageTitle,
                    description: industry + " | " + location
                };
                if(user_data && user_data.branding_pref){
                    if(user_data.branding_pref.primary_color){
                        slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                    }
                    if(user_data.branding_pref.secondary_color){
                        slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                    }
                    if(user_data.branding_image){
                        slide.branding_image = user_data.branding_image;
                    }
                }
                try {
                    if(user_data && user_data.branding_pref){
                        slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                        slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    }
                } catch (e) {}
                slides.push(slide);
            }

            for(let i = 0; i < images.length; i++){
                if(images[i].label && slides.length < 9){
                    let slide = {
                        image: "",
                        image_title: null,
                        title: "",
                        description: industry + " | " + location
                    };
                    if(Array.isArray(items)){
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && +items[m].label === +images[i].label.id && !slide.image_title){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                    }
                    if(!slide.image_title && Array.isArray(items)){
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && (!items[m].label && items[m].label !== 0)){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                    }
                    if(!slide.image_title){
                        slide.image_title = images[i].label.title;
                    }
                    slide.image = images[i].images.small;
                    slide.title = images[i].label.title;
                    if(user_data && user_data.branding_pref){
                        if(user_data.branding_pref.primary_color){
                            slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                        }
                        if(user_data.branding_pref.secondary_color){
                            slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                        }
                        if(user_data.branding_image){
                            slide.branding_image = user_data.branding_image;
                        }
                    }
                    try {
                        if(user_data && user_data.branding_pref){
                            slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                            slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                        }
                    } catch (e) {}
                    slides.push(slide);
                }
            }

            let objects = [];
            //let url = "http://localhost:5001/";
            let url = "https://coral-app-xg6gr.ondigitalocean.app/";
            objects.push({
                image: url + collectedRegister.getValue("reseller_name") + "/carousel/" + theme + "/first?" + query + "&legacy=false",
                title: data_custom_creative.first_title,
                description: data_custom_creative.first_subtitle
            });
            slides.map((item) => {
                objects.push({
                    image: url + collectedRegister.getValue("reseller_name") + "/carousel/" + theme + "/center?image=" + item.image + "&title=" + item.image_title + "&legacy=false",
                    title: item.title,
                    description: item.description
                });
            });
            objects.push({
                image: url + collectedRegister.getValue("reseller_name") + "/carousel/" + theme + "/last?" + query + "&legacy=false",
                title: data_custom_creative.last_title,
                description: data_custom_creative.last_subtitle
            });
            return objects;

        } else {

            let data = themeRegister.getValue();
            let theme = themeRegister.getTheme();

            let theme_data = themeRegister.getValue();
            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();

            if(user_data && user_data.branding_pref){
                data.primary_color = user_data.branding_pref.primary_color;
                data.secondary_color = user_data.branding_pref.secondary_color;
                data.branding_image = user_data.branding_image;
            }

            try {
                if(user_data && user_data.branding_pref){
                    data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                    data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                    data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                }
            } catch (e) {}

            if(!data.agent_description && user_data.company_name){
                data.agent_description = user_data.company_name;
            }
            if(!data.agent_description && user_data.billing_company){
                data.agent_description = user_data.billing_company;
            }

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.email){
                    try{
                        let split_email = agent_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(agent_data && agent_data.name){
                    data.agent_name = agent_data.name;
                }
                if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                    data.agent_phone = user_data.phone;
                } else {
                    if (agent_data && agent_data.phone) {
                        data.agent_phone = agent_data.phone;
                    }
                }
            }else{
                if(user_data && user_data.profile_image){
                    data.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.email){
                    try{
                        let split_email = user_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(user_data && user_data.name){
                    data.agent_name = user_data.name;
                }
                if(user_data && user_data.phone){
                    data.agent_phone = user_data.phone;
                }
            }

            if(theme === "broker"){
                data.slogan_validation = data.last_title;
            }

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            let query = queryString.stringify(data);
            let images = imagesRegister.get();
            let mainImage = imagesRegister.getMain();
            let mainImageTitle = flowRegister.getValue("main_image_title");
            let items = Array.isArray(flowRegister.getValue("video_items"))?flowRegister.getValue("video_items"):[];
            let location = flowRegister.getValue("display_region");
            let industry = "";
            try {
                industry = cartRegister.get().industry.name;
            }catch (e) {}
            let slides = [];

            /*
            let type = themeRegister.getThemeType();
            let extra_image = "";
            if(type !== "no_theme" && data){
                let user_data = userRegister.getUser();
                if(type === "agent_theme" && user_data && user_data.profile_image){
                    data.theme_type = type;
                    extra_image = user_data.profile_image;
                }
                if(type === "agency_theme" && user_data && user_data.logo_image){
                    data.theme_type = type;
                    extra_image = user_data.logo_image;
                }
            }
             */

            if(mainImage){
                let slide = {
                    image: mainImage.images.small,
                    image_title: mainImageTitle,
                    title: mainImageTitle,
                    description: industry + " | " + location
                };
                if(user_data && user_data.branding_pref){
                    if(user_data.branding_pref.primary_color){
                        slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                    }
                    if(user_data.branding_pref.secondary_color){
                        slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                    }
                    if(user_data.branding_image){
                        slide.branding_image = user_data.branding_image;
                    }
                }
                try {
                    if(user_data && user_data.branding_pref){
                        slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                        slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    }
                } catch (e) {}
                slides.push(slide);
            }

            for(let i = 0; i < images.length; i++){
                if(images[i].label && slides.length < 9){
                    let slide = {
                        image: "",
                        image_title: null,
                        title: "",
                        description: industry + " | " + location
                    };
                    if(Array.isArray(items)){
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && +items[m].label === +images[i].label.id && !slide.image_title){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                    }
                    if(!slide.image_title && Array.isArray(items)){
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && (!items[m].label && items[m].label !== 0)){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                    }
                    if(!slide.image_title){
                        slide.image_title = images[i].label.title;
                    }
                    slide.image = images[i].images.small;
                    slide.title = images[i].label.title;
                    if(user_data && user_data.branding_pref){
                        if(user_data.branding_pref.primary_color){
                            slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                        }
                        if(user_data.branding_pref.secondary_color){
                            slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                        }
                        if(user_data.branding_image){
                            slide.branding_image = user_data.branding_image;
                        }
                    }
                    try {
                        if(user_data && user_data.branding_pref){
                            slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                            slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                        }
                    } catch (e) {}
                    slides.push(slide);
                }
            }

            let objects = [];
            //let url = "http://localhost:3001/";
            let url = "https://preview." + dataRegister.domain + "/";
            objects.push({
                image: url + salesChannelRegister.get("name")+"/carousel/"+theme+"/first?" + query,
                title: data.first_title,
                description: data.first_subtitle
            });
            slides.map((item) => {
                objects.push({
                    image: url + salesChannelRegister.get("name")+"/carousel/"+theme+"/center?image=" + item.image + "&title=" + item.image_title + (item.primary_color?("&primary_color=" + item.primary_color + "&secondary_color=" +item.secondary_color):"") + "&infobox_m=" + item.infobox_m + "&infobox_s=" +item.infobox_s,
                    title: item.title,
                    description: item.description
                });
            });
            objects.push({
                image: url + salesChannelRegister.get("name")+"/carousel/"+theme+"/last?" + query,
                title: data.last_title,
                description: data.last_subtitle
            });
            return objects;
        }
    }

    static set(value, hash){
        carouselRegister.video.url = value;
        carouselRegister.video.hash = hash;
        try {
            sessionStorage.setItem("carousel", JSON.stringify(carouselRegister.video));
        }catch (e) {}
    }

    static get(){
        if(carouselRegister.video.url && carouselRegister.video.hash){
            return carouselRegister.video;
        }else{
            try {
                if(JSON.parse(sessionStorage.getItem("carousel")).hash && JSON.parse(sessionStorage.getItem("carousel")).url){
                    return JSON.parse(sessionStorage.getItem("carousel"));
                }
            }catch (e) {}
        }
    }

    static remove(){
        cartRegister.video = {hash: null, url: null};
        try {
            sessionStorage.removeItem("carousel");
        }catch (e) {}
    }


}

export {carouselRegister}


// WEBPACK FOOTER //
// ./src/services/carouselRegister.js